import React, { useEffect, useRef } from "react";

export default function usePrevious<T>(value: T): T {
  const ref: any = useRef("");

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}



// WEBPACK FOOTER //
// ./src/utils/usePrevious.tsx